/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { AppConfig, CHANNELS } from "@nf/constants";
import { IThemeContext } from "../context/ThemeContext";
import { MediaChannelType } from "../enums";

export type ChannelKey = typeof CHANNELS[keyof typeof CHANNELS];

export const setBrandingFromUrl = (
  screenKey: string,
  channelContext: IThemeContext
) => {
  if (channelContext.onBrandingChange && !screenKey) {
    channelContext.onBrandingChange(CHANNELS.NF_PLUS);
  }
  if (channelContext.onBrandingChange && screenKey) {
    switch (screenKey) {
      case AppConfig?.ChannelDansk:
        channelContext.onBrandingChange(CHANNELS.DANSK_FILMSKAT);
        break;
      case AppConfig?.ChannelKids:
        channelContext.onBrandingChange(CHANNELS.KIDS);
        break;
      case "kids":
        channelContext.onBrandingChange(CHANNELS.KIDS);
        break;
      default:
        channelContext.onBrandingChange(CHANNELS.NF_PLUS);
        break;
    }
  }
};

// TODO Handle other countries the better way
// API screen ID -> branding key
export const SCREEN_ID_TO_CHANNEL: Record<string, ChannelKey> = {
  [AppConfig?.ChannelDansk]: CHANNELS.DANSK_FILMSKAT,
  [AppConfig?.ChannelKids]: CHANNELS.KIDS,
  [AppConfig?.ChannelHome]: CHANNELS.NF_PLUS,
  // Finnish
  ["home"]: CHANNELS.NF_PLUS,
  ["kids"]: CHANNELS.KIDS,
};

// TODO Handle other countries the better way
// API screen ID -> asset channel id
export const SCREEN_ID_TO_MEDIA_CHANNEL = {
  [AppConfig.ChannelHome]: MediaChannelType.NFplus,
  [AppConfig.ChannelDansk]: MediaChannelType.Dansk_Filmskat,
  [AppConfig.ChannelKids]: MediaChannelType.Kids,
  // Finnish
  ["home"]: MediaChannelType.NFplus,
  ["kids"]: MediaChannelType.Kids,
};

export const getChannelFromScreenId = (
  screenId?: string | number
): ChannelKey => {
  return (screenId && SCREEN_ID_TO_CHANNEL[screenId]) || CHANNELS.NF_PLUS;
};

export const getMediaChannelFromScreenId = (screenId: string) => {
  return SCREEN_ID_TO_MEDIA_CHANNEL[screenId];
};

// TODO Handle other countries the better way
export const CHANNEL_LOGOS: Record<
  string,
  { compact: string; full: string; labeled: string }
> = {
  ["hjem"]: {
    compact: "/assets/channels/home/compact.svg",
    full: "/assets/channels/home/full.svg",
    labeled: "/assets/channels/home/labeled.svg",
  },
  ["danskfilmskat"]: {
    compact: "/assets/channels/dansk/compact.svg",
    full: "/assets/channels/dansk/full.svg",
    labeled: "/assets/channels/dansk/labeled.svg",
  },
  ["boern"]: {
    compact: "/assets/channels/kids/compact.svg",
    full: "/assets/channels/kids/full.svg",
    labeled: "/assets/channels/kids/labeled.svg",
  },
  // Finnish
  ["home"]: {
    compact: "/assets/channels/home/compact.svg",
    full: "/assets/channels/home/full.svg",
    labeled: "/assets/channels/home/labeled.svg",
  },
  ["kids"]: {
    compact: "/assets/channels/kids/compact.svg",
    full: "/assets/channels/kids/full.svg",
    labeled: "/assets/channels/kids/full.svg",
  },
};
